/** Internal dependencies */
import whenDocumentReady from '../../../../../assets/src/scripts/utilities/whenDocumentReady';
import { counter } from './components/counter';

whenDocumentReady(initWidget);

function initWidget() {
    // do what needs to be done
    const counters = document.querySelectorAll('[data-ct-counter]');

    if (counters) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    // skip if not currently intersecting
                    return;
                }

                const counterEl = entry.target;
                counter(counterEl);
                observer.unobserve(counterEl);
            });
        });
        counters.forEach((counterEl) => {
            if (window.matchMedia('(prefers-reduced-motion)').matches) {
                const endValue = counterEl.dataset?.ctCounterEndValue;

                if (endValue) {
                    counterEl.textContent = endValue;
                }
            } else {
                observer.observe(counterEl);
            }
        });
    }
}
